export default __webpack_public_path__ + "static/media/vertical.7ec6fb86.png";